export default {"src":"/_next/static/media/SPIR.d8b16f22.svg","height":18,"width":18};